/**
 * Generated from MaryShelleyStoryLayout.fla
 */
export function MaryShelleyStoryLayout(this: IMaryShelleyStoryLayout) {
	const scene1Start = this.scene1Start;
	MaryShelleyStoryLayout_scene1Start.call(this.scene1Start);
	scene1Start.x = 0;
	scene1Start.y = 0;
	if (scene1Start.onLayout) scene1Start.onLayout();
	const scene2Encounter = this.scene2Encounter;
	MaryShelleyStoryLayout_scene2Encounter.call(this.scene2Encounter);
	scene2Encounter.x = 0;
	scene2Encounter.y = 0;
	if (scene2Encounter.onLayout) scene2Encounter.onLayout();
	const scene3Reaction = this.scene3Reaction;
	MaryShelleyStoryLayout_scene3Reaction.call(this.scene3Reaction);
	scene3Reaction.x = 0;
	scene3Reaction.y = 0;
	if (scene3Reaction.onLayout) scene3Reaction.onLayout();
	const scene4Trait = this.scene4Trait;
	MaryShelleyStoryLayout_scene4Trait.call(this.scene4Trait);
	scene4Trait.x = 0;
	scene4Trait.y = 0;
	if (scene4Trait.onLayout) scene4Trait.onLayout();
	const scene5Trait = this.scene5Trait;
	MaryShelleyStoryLayout_scene5Trait.call(this.scene5Trait);
	scene5Trait.x = 0;
	scene5Trait.y = 0;
	if (scene5Trait.onLayout) scene5Trait.onLayout();
	const scene6End = this.scene6End;
	MaryShelleyStoryLayout_scene6End.call(this.scene6End);
	scene6End.x = 0;
	scene6End.y = 0;
	if (scene6End.onLayout) scene6End.onLayout();
	return this;
}
export function MaryShelleyStoryLayout_scene1Start(this: IMaryShelleyStoryLayout_scene1Start) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBg.call(items[0] as IMaryShelleyStoryLayout_sheBg);
		items[0].x = -150.55;
		items[0].y = 0;
		items[0].width = 2395.00;
		items[0].height = 1057.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_paperLayer.call(items[1] as IMaryShelleyStoryLayout_paperLayer);
		(items[1] as IMaryShelleyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_slotXavier.call(items[2] as IMaryShelleyStoryLayout_slotXavier);
		(items[2] as IMaryShelleyStoryLayout_slotXavier).animation = "scaleUp ease=squishStretch";
		(items[2] as IMaryShelleyStoryLayout_slotXavier).isButton = true;
		(items[2] as IMaryShelleyStoryLayout_slotXavier).option = "";
		items[2].x = 1025.05;
		items[2].y = 1182.6;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheBg(this: IMaryShelleyStoryLayout_sheBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bg.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_paperLayer(this: IMaryShelleyStoryLayout_paperLayer) {
	return this;
}
function MaryShelleyStoryLayout_slotXavier(this: IMaryShelleyStoryLayout_slotXavier) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"surprising"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheXSurprised.call(items[0] as IMaryShelleyStoryLayout_sheXSurprised);
		(items[0] as IMaryShelleyStoryLayout_sheXSurprised).option = "surprising";
		items[0].x = -177;
		items[0].y = -651;
		items[0].width = 354.00;
		items[0].height = 651.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"spooky"});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheXSpooky.call(items[1] as IMaryShelleyStoryLayout_sheXSpooky);
		(items[1] as IMaryShelleyStoryLayout_sheXSpooky).option = "spooky";
		items[1].x = -179;
		items[1].y = -635;
		items[1].width = 358.00;
		items[1].height = 635.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"funny"});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheXFunny.call(items[2] as IMaryShelleyStoryLayout_sheXFunny);
		(items[2] as IMaryShelleyStoryLayout_sheXFunny).animation = "";
		(items[2] as IMaryShelleyStoryLayout_sheXFunny).isButton = false;
		(items[2] as IMaryShelleyStoryLayout_sheXFunny).option = "funny";
		items[2].x = -178.5;
		items[2].y = -651;
		items[2].width = 357.00;
		items[2].height = 651.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheXSurprised(this: IMaryShelleyStoryLayout_sheXSurprised) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-surprised.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXSpooky(this: IMaryShelleyStoryLayout_sheXSpooky) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-spooky.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXFunny(this: IMaryShelleyStoryLayout_sheXFunny) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-funny.png", 0.000, 0.000);
	return this;
}
export function MaryShelleyStoryLayout_scene2Encounter(this: IMaryShelleyStoryLayout_scene2Encounter) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBg.call(items[0] as IMaryShelleyStoryLayout_sheBg);
		items[0].x = -150.55;
		items[0].y = 0;
		items[0].width = 2395.00;
		items[0].height = 1057.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_paperLayer.call(items[1] as IMaryShelleyStoryLayout_paperLayer);
		(items[1] as IMaryShelleyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":""});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_slotXavier.call(items[2] as IMaryShelleyStoryLayout_slotXavier);
		(items[2] as IMaryShelleyStoryLayout_slotXavier).animation = "";
		(items[2] as IMaryShelleyStoryLayout_slotXavier).isButton = true;
		(items[2] as IMaryShelleyStoryLayout_slotXavier).option = "";
		items[2].x = 559;
		items[2].y = 1182.6;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":""});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_slotEncounter0.call(items[3] as IMaryShelleyStoryLayout_slotEncounter0);
		(items[3] as IMaryShelleyStoryLayout_slotEncounter0).animation = "";
		(items[3] as IMaryShelleyStoryLayout_slotEncounter0).isButton = true;
		(items[3] as IMaryShelleyStoryLayout_slotEncounter0).option = "";
		items[3].x = 1333.95;
		items[3].y = 1164.3;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_slotEncounter0(this: IMaryShelleyStoryLayout_slotEncounter0) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"superhero"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheSuperhero0.call(items[0] as IMaryShelleyStoryLayout_sheSuperhero0);
		(items[0] as IMaryShelleyStoryLayout_sheSuperhero0).option = "superhero";
		items[0].x = -195.5;
		items[0].y = -674.75;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"ghost"});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheGhost0.call(items[1] as IMaryShelleyStoryLayout_sheGhost0);
		(items[1] as IMaryShelleyStoryLayout_sheGhost0).option = "ghost";
		items[1].x = -312.75;
		items[1].y = -798.5;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"ant"});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheAnt0.call(items[2] as IMaryShelleyStoryLayout_sheAnt0);
		(items[2] as IMaryShelleyStoryLayout_sheAnt0).option = "ant";
		items[2].x = -354.5;
		items[2].y = -445.25;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"monster"});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_sheBookmonster0.call(items[3] as IMaryShelleyStoryLayout_sheBookmonster0);
		(items[3] as IMaryShelleyStoryLayout_sheBookmonster0).option = "monster";
		items[3].x = 94.25;
		items[3].y = 0;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheSuperhero0(this: IMaryShelleyStoryLayout_sheSuperhero0) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"scaleUp ease=squishStretch"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_shesuperheroAnimatable.call(items[0] as IMaryShelleyStoryLayout_shesuperheroAnimatable);
		(items[0] as IMaryShelleyStoryLayout_shesuperheroAnimatable).animation = "scaleUp ease=squishStretch";
		items[0].x = 195.5;
		items[0].y = 697;
		items[0].width = 391.00;
		items[0].height = 697.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_shesuperheroAnimatable(this: IMaryShelleyStoryLayout_shesuperheroAnimatable) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-superhero.png", 0.500, 1.000);
	return this;
}
function MaryShelleyStoryLayout_sheGhost0(this: IMaryShelleyStoryLayout_sheGhost0) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"floatIn right"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheGhostAnimatable.call(items[0] as IMaryShelleyStoryLayout_sheGhostAnimatable);
		(items[0] as IMaryShelleyStoryLayout_sheGhostAnimatable).animation = "floatIn right";
		items[0].x = 313.5;
		items[0].y = 841;
		items[0].width = 627.00;
		items[0].height = 841.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheGhostAnimatable(this: IMaryShelleyStoryLayout_sheGhostAnimatable) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-ghost.png", 0.500, 1.000);
	return this;
}
function MaryShelleyStoryLayout_sheAnt0(this: IMaryShelleyStoryLayout_sheAnt0) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"bobIn right quick"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheAntAnimatable.call(items[0] as IMaryShelleyStoryLayout_sheAntAnimatable);
		(items[0] as IMaryShelleyStoryLayout_sheAntAnimatable).animation = "bobIn right quick";
		items[0].x = 332;
		items[0].y = 381;
		items[0].width = 624.00;
		items[0].height = 471.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheAntAnimatable(this: IMaryShelleyStoryLayout_sheAntAnimatable) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-ant.png", 0.532, 0.809);
	return this;
}
function MaryShelleyStoryLayout_sheBookmonster0(this: IMaryShelleyStoryLayout_sheBookmonster0) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"stompIn right"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBookmonsterAnimatable.call(items[0] as IMaryShelleyStoryLayout_sheBookmonsterAnimatable);
		(items[0] as IMaryShelleyStoryLayout_sheBookmonsterAnimatable).animation = "stompIn right";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheBookmonsterAnimatable(this: IMaryShelleyStoryLayout_sheBookmonsterAnimatable) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":""});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBookmonsterArmup.call(items[0] as IMaryShelleyStoryLayout_sheBookmonsterArmup);
		(items[0] as IMaryShelleyStoryLayout_sheBookmonsterArmup).option = "";
		items[0].x = -619;
		items[0].y = -810.4;
		items[0].width = 447.00;
		items[0].height = 375.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":""});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheBookmonster.call(items[1] as IMaryShelleyStoryLayout_sheBookmonster);
		(items[1] as IMaryShelleyStoryLayout_sheBookmonster).option = "";
		items[1].x = -376.95;
		items[1].y = -906;
		items[1].width = 996.00;
		items[1].height = 906.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheBookmonsterArmup(this: IMaryShelleyStoryLayout_sheBookmonsterArmup) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bookmonster-armup.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheBookmonster(this: IMaryShelleyStoryLayout_sheBookmonster) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bookmonster.png", 0.000, 0.000);
	return this;
}
export function MaryShelleyStoryLayout_scene3Reaction(this: IMaryShelleyStoryLayout_scene3Reaction) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBg.call(items[0] as IMaryShelleyStoryLayout_sheBg);
		items[0].x = -150.55;
		items[0].y = 0;
		items[0].width = 2395.00;
		items[0].height = 1057.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_paperLayer.call(items[1] as IMaryShelleyStoryLayout_paperLayer);
		(items[1] as IMaryShelleyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_slotXavier1.call(items[2] as IMaryShelleyStoryLayout_slotXavier1);
		(items[2] as IMaryShelleyStoryLayout_slotXavier1).animation = "scaleUp ease=squishStretch";
		(items[2] as IMaryShelleyStoryLayout_slotXavier1).isButton = true;
		(items[2] as IMaryShelleyStoryLayout_slotXavier1).option = "";
		items[2].x = 559;
		items[2].y = 1182.6;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":""});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_slotEncounter.call(items[3] as IMaryShelleyStoryLayout_slotEncounter);
		(items[3] as IMaryShelleyStoryLayout_slotEncounter).animation = "";
		(items[3] as IMaryShelleyStoryLayout_slotEncounter).isButton = true;
		(items[3] as IMaryShelleyStoryLayout_slotEncounter).option = "";
		items[3].x = 1333.95;
		items[3].y = 1164.3;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_slotXavier1(this: IMaryShelleyStoryLayout_slotXavier1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"run"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheXRun.call(items[0] as IMaryShelleyStoryLayout_sheXRun);
		(items[0] as IMaryShelleyStoryLayout_sheXRun).option = "run";
		items[0].x = -309.2;
		items[0].y = -627;
		items[0].width = 460.00;
		items[0].height = 627.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"hide"});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheXHide.call(items[1] as IMaryShelleyStoryLayout_sheXHide);
		(items[1] as IMaryShelleyStoryLayout_sheXHide).option = "hide";
		items[1].x = -375.2;
		items[1].y = -463;
		items[1].width = 592.00;
		items[1].height = 463.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"invisible"});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheXInvisible.call(items[2] as IMaryShelleyStoryLayout_sheXInvisible);
		(items[2] as IMaryShelleyStoryLayout_sheXInvisible).option = "invisible";
		items[2].x = -261.7;
		items[2].y = -665;
		items[2].width = 365.00;
		items[2].height = 665.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"statue"});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_sheXStatue.call(items[3] as IMaryShelleyStoryLayout_sheXStatue);
		(items[3] as IMaryShelleyStoryLayout_sheXStatue).option = "statue";
		items[3].x = -249.7;
		items[3].y = -721;
		items[3].width = 408.00;
		items[3].height = 721.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheXRun(this: IMaryShelleyStoryLayout_sheXRun) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-run.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXHide(this: IMaryShelleyStoryLayout_sheXHide) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-hide.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXInvisible(this: IMaryShelleyStoryLayout_sheXInvisible) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-invisible.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXStatue(this: IMaryShelleyStoryLayout_sheXStatue) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-statue.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_slotEncounter(this: IMaryShelleyStoryLayout_slotEncounter) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"superhero"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheSuperhero.call(items[0] as IMaryShelleyStoryLayout_sheSuperhero);
		(items[0] as IMaryShelleyStoryLayout_sheSuperhero).option = "superhero";
		items[0].x = -195.5;
		items[0].y = -674.75;
		items[0].width = 391.00;
		items[0].height = 697.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"ghost"});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheGhost.call(items[1] as IMaryShelleyStoryLayout_sheGhost);
		(items[1] as IMaryShelleyStoryLayout_sheGhost).option = "ghost";
		items[1].x = -312.75;
		items[1].y = -798.5;
		items[1].width = 627.00;
		items[1].height = 841.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"ant"});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheAnt.call(items[2] as IMaryShelleyStoryLayout_sheAnt);
		(items[2] as IMaryShelleyStoryLayout_sheAnt).option = "ant";
		items[2].x = -354.5;
		items[2].y = -445.25;
		items[2].width = 624.00;
		items[2].height = 471.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"monster"});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_sheBookmonsterArmup.call(items[3] as IMaryShelleyStoryLayout_sheBookmonsterArmup);
		(items[3] as IMaryShelleyStoryLayout_sheBookmonsterArmup).option = "monster";
		items[3].x = -524.75;
		items[3].y = -810.4;
		items[3].width = 447.00;
		items[3].height = 375.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"monster"});
	}
	if (items[4]) {
		MaryShelleyStoryLayout_sheBookmonster.call(items[4] as IMaryShelleyStoryLayout_sheBookmonster);
		(items[4] as IMaryShelleyStoryLayout_sheBookmonster).option = "monster";
		items[4].x = -282.7;
		items[4].y = -906;
		items[4].width = 996.00;
		items[4].height = 906.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheSuperhero(this: IMaryShelleyStoryLayout_sheSuperhero) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-superhero.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheGhost(this: IMaryShelleyStoryLayout_sheGhost) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-ghost.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheAnt(this: IMaryShelleyStoryLayout_sheAnt) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-ant.png", 0.000, 0.000);
	return this;
}
export function MaryShelleyStoryLayout_scene4Trait(this: IMaryShelleyStoryLayout_scene4Trait) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBg.call(items[0] as IMaryShelleyStoryLayout_sheBg);
		items[0].x = -150.55;
		items[0].y = 0;
		items[0].width = 2395.00;
		items[0].height = 1057.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_paperLayer.call(items[1] as IMaryShelleyStoryLayout_paperLayer);
		(items[1] as IMaryShelleyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_slotXavier2.call(items[2] as IMaryShelleyStoryLayout_slotXavier2);
		(items[2] as IMaryShelleyStoryLayout_slotXavier2).animation = "scaleUp ease=squishStretch";
		(items[2] as IMaryShelleyStoryLayout_slotXavier2).isButton = true;
		(items[2] as IMaryShelleyStoryLayout_slotXavier2).option = "";
		items[2].x = 559;
		items[2].y = 1182.6;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":""});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_slotEncounter.call(items[3] as IMaryShelleyStoryLayout_slotEncounter);
		(items[3] as IMaryShelleyStoryLayout_slotEncounter).animation = "";
		(items[3] as IMaryShelleyStoryLayout_slotEncounter).isButton = true;
		(items[3] as IMaryShelleyStoryLayout_slotEncounter).option = "";
		items[3].x = 1333.95;
		items[3].y = 1164.3;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_slotXavier2(this: IMaryShelleyStoryLayout_slotXavier2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"traitBrave"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheXBrave.call(items[0] as IMaryShelleyStoryLayout_sheXBrave);
		(items[0] as IMaryShelleyStoryLayout_sheXBrave).option = "traitBrave";
		items[0].x = -194.5;
		items[0].y = -660;
		items[0].width = 389.00;
		items[0].height = 660.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"traitKind"});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheXKind.call(items[1] as IMaryShelleyStoryLayout_sheXKind);
		(items[1] as IMaryShelleyStoryLayout_sheXKind).option = "traitKind";
		items[1].x = -244;
		items[1].y = -724;
		items[1].width = 488.00;
		items[1].height = 724.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"traitFunny"});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheXFunny_2.call(items[2] as IMaryShelleyStoryLayout_sheXFunny_2);
		(items[2] as IMaryShelleyStoryLayout_sheXFunny_2).option = "traitFunny";
		items[2].x = -182;
		items[2].y = -683;
		items[2].width = 364.00;
		items[2].height = 683.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheXBrave(this: IMaryShelleyStoryLayout_sheXBrave) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-brave.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXKind(this: IMaryShelleyStoryLayout_sheXKind) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-kind.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXFunny_2(this: IMaryShelleyStoryLayout_sheXFunny_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-funny_2.png", 0.000, 0.000);
	return this;
}
export function MaryShelleyStoryLayout_scene5Trait(this: IMaryShelleyStoryLayout_scene5Trait) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBg.call(items[0] as IMaryShelleyStoryLayout_sheBg);
		items[0].x = -150.55;
		items[0].y = 0;
		items[0].width = 2395.00;
		items[0].height = 1057.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_paperLayer.call(items[1] as IMaryShelleyStoryLayout_paperLayer);
		(items[1] as IMaryShelleyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":""});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_slotEncounter.call(items[2] as IMaryShelleyStoryLayout_slotEncounter);
		(items[2] as IMaryShelleyStoryLayout_slotEncounter).animation = "";
		(items[2] as IMaryShelleyStoryLayout_slotEncounter).isButton = true;
		(items[2] as IMaryShelleyStoryLayout_slotEncounter).option = "";
		items[2].x = 1333.95;
		items[2].y = 1164.3;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_slotXavier3.call(items[3] as IMaryShelleyStoryLayout_slotXavier3);
		(items[3] as IMaryShelleyStoryLayout_slotXavier3).animation = "scaleUp ease=squishStretch";
		(items[3] as IMaryShelleyStoryLayout_slotXavier3).isButton = true;
		(items[3] as IMaryShelleyStoryLayout_slotXavier3).option = "";
		items[3].x = 550.2;
		items[3].y = 1179.7;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_slotXavier3(this: IMaryShelleyStoryLayout_slotXavier3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"traitBrave"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheXDefend.call(items[0] as IMaryShelleyStoryLayout_sheXDefend);
		(items[0] as IMaryShelleyStoryLayout_sheXDefend).option = "traitBrave";
		items[0].x = -216.15;
		items[0].y = -678.1;
		items[0].width = 433.00;
		items[0].height = 681.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"traitKind"});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheXShare.call(items[1] as IMaryShelleyStoryLayout_sheXShare);
		(items[1] as IMaryShelleyStoryLayout_sheXShare).option = "traitKind";
		items[1].x = -216.15;
		items[1].y = -675.25;
		items[1].width = 431.00;
		items[1].height = 678.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"traitFunny"});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheXFunny.call(items[2] as IMaryShelleyStoryLayout_sheXFunny);
		(items[2] as IMaryShelleyStoryLayout_sheXFunny).animation = "";
		(items[2] as IMaryShelleyStoryLayout_sheXFunny).isButton = false;
		(items[2] as IMaryShelleyStoryLayout_sheXFunny).option = "traitFunny";
		items[2].x = -208.05;
		items[2].y = -649.75;
		items[2].width = 357.00;
		items[2].height = 650.99;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"wand"});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_sheWandButtonimg.call(items[3] as IMaryShelleyStoryLayout_sheWandButtonimg);
		(items[3] as IMaryShelleyStoryLayout_sheWandButtonimg).option = "wand";
		items[3].x = 142.55;
		items[3].y = -613.65;
		items[3].width = 325.00;
		items[3].height = 322.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"lantern"});
	}
	if (items[4]) {
		MaryShelleyStoryLayout_sheLanternButtonimg.call(items[4] as IMaryShelleyStoryLayout_sheLanternButtonimg);
		(items[4] as IMaryShelleyStoryLayout_sheLanternButtonimg).option = "lantern";
		items[4].x = 75.85;
		items[4].y = -390.95;
		items[4].width = 219.00;
		items[4].height = 355.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"flashlight"});
	}
	if (items[5]) {
		MaryShelleyStoryLayout_sheFlashlightButtonimg.call(items[5] as IMaryShelleyStoryLayout_sheFlashlightButtonimg);
		(items[5] as IMaryShelleyStoryLayout_sheFlashlightButtonimg).option = "flashlight";
		items[5].x = 89.05;
		items[5].y = -585.5;
		items[5].width = 352.00;
		items[5].height = 348.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"option":"broccoli"});
	}
	if (items[6]) {
		MaryShelleyStoryLayout_sheBroccoliButtonimg.call(items[6] as IMaryShelleyStoryLayout_sheBroccoliButtonimg);
		(items[6] as IMaryShelleyStoryLayout_sheBroccoliButtonimg).option = "broccoli";
		items[6].x = 119.3;
		items[6].y = -544.4;
		items[6].width = 283.00;
		items[6].height = 272.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"toy"});
	}
	if (items[7]) {
		MaryShelleyStoryLayout_sheToyButtonimg.call(items[7] as IMaryShelleyStoryLayout_sheToyButtonimg);
		(items[7] as IMaryShelleyStoryLayout_sheToyButtonimg).option = "toy";
		items[7].x = 95.65;
		items[7].y = -446.45;
		items[7].width = 244.00;
		items[7].height = 177.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"option":"bear"});
	}
	if (items[8]) {
		MaryShelleyStoryLayout_sheTeddybearButtonimg.call(items[8] as IMaryShelleyStoryLayout_sheTeddybearButtonimg);
		(items[8] as IMaryShelleyStoryLayout_sheTeddybearButtonimg).option = "bear";
		items[8].x = 92.45;
		items[8].y = -497.15;
		items[8].width = 240.00;
		items[8].height = 292.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"option":"sandwich"});
	}
	if (items[9]) {
		MaryShelleyStoryLayout_sheSandwichButtonimg.call(items[9] as IMaryShelleyStoryLayout_sheSandwichButtonimg);
		(items[9] as IMaryShelleyStoryLayout_sheSandwichButtonimg).option = "sandwich";
		items[9].x = 123.2;
		items[9].y = -456.75;
		items[9].width = 204.00;
		items[9].height = 203.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"option":"crayons"});
	}
	if (items[10]) {
		MaryShelleyStoryLayout_sheCrayonsButtonimg.call(items[10] as IMaryShelleyStoryLayout_sheCrayonsButtonimg);
		(items[10] as IMaryShelleyStoryLayout_sheCrayonsButtonimg).option = "crayons";
		items[10].x = 125.7;
		items[10].y = -434.55;
		items[10].width = 162.99;
		items[10].height = 162.99;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"option":"tophat"});
	}
	if (items[11]) {
		MaryShelleyStoryLayout_sheTophatButtonimg.call(items[11] as IMaryShelleyStoryLayout_sheTophatButtonimg);
		(items[11] as IMaryShelleyStoryLayout_sheTophatButtonimg).option = "tophat";
		items[11].x = -255.7;
		items[11].y = -889.2;
		items[11].width = 450.00;
		items[11].height = 413.99;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"option":"glasses"});
	}
	if (items[12]) {
		MaryShelleyStoryLayout_sheSillyglassesButtonimg.call(items[12] as IMaryShelleyStoryLayout_sheSillyglassesButtonimg);
		(items[12] as IMaryShelleyStoryLayout_sheSillyglassesButtonimg).option = "glasses";
		items[12].x = -155;
		items[12].y = -479.25;
		items[12].width = 320.17;
		items[12].height = 146.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"option":"moustache"});
	}
	if (items[13]) {
		MaryShelleyStoryLayout_sheMoustacheButtonimg.call(items[13] as IMaryShelleyStoryLayout_sheMoustacheButtonimg);
		(items[13] as IMaryShelleyStoryLayout_sheMoustacheButtonimg).option = "moustache";
		items[13].x = -117.4;
		items[13].y = -371.45;
		items[13].width = 281.00;
		items[13].height = 68.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"option":"bowtie"});
	}
	if (items[14]) {
		MaryShelleyStoryLayout_sheBowtieButtonimg.call(items[14] as IMaryShelleyStoryLayout_sheBowtieButtonimg);
		(items[14] as IMaryShelleyStoryLayout_sheBowtieButtonimg).option = "bowtie";
		items[14].x = -93.8;
		items[14].y = -315.65;
		items[14].width = 195.00;
		items[14].height = 104.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheXDefend(this: IMaryShelleyStoryLayout_sheXDefend) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-defend.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXShare(this: IMaryShelleyStoryLayout_sheXShare) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-share.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheWandButtonimg(this: IMaryShelleyStoryLayout_sheWandButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-wand.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheLanternButtonimg(this: IMaryShelleyStoryLayout_sheLanternButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-lantern.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheFlashlightButtonimg(this: IMaryShelleyStoryLayout_sheFlashlightButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-flashlight.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheBroccoliButtonimg(this: IMaryShelleyStoryLayout_sheBroccoliButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-broccoli.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheToyButtonimg(this: IMaryShelleyStoryLayout_sheToyButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-toy.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheTeddybearButtonimg(this: IMaryShelleyStoryLayout_sheTeddybearButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-teddybear.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheSandwichButtonimg(this: IMaryShelleyStoryLayout_sheSandwichButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-sandwich.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheCrayonsButtonimg(this: IMaryShelleyStoryLayout_sheCrayonsButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-crayons.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheTophatButtonimg(this: IMaryShelleyStoryLayout_sheTophatButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-tophat.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheSillyglassesButtonimg(this: IMaryShelleyStoryLayout_sheSillyglassesButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-sillyglasses.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheMoustacheButtonimg(this: IMaryShelleyStoryLayout_sheMoustacheButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-moustache.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheBowtieButtonimg(this: IMaryShelleyStoryLayout_sheBowtieButtonimg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bowtie.png", 0.000, 0.000);
	return this;
}
export function MaryShelleyStoryLayout_scene6End(this: IMaryShelleyStoryLayout_scene6End) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBg.call(items[0] as IMaryShelleyStoryLayout_sheBg);
		items[0].x = -150.55;
		items[0].y = 0;
		items[0].width = 2395.00;
		items[0].height = 1057.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_paperLayer.call(items[1] as IMaryShelleyStoryLayout_paperLayer);
		(items[1] as IMaryShelleyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"boogie"});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheBoogie.call(items[2] as IMaryShelleyStoryLayout_sheBoogie);
		(items[2] as IMaryShelleyStoryLayout_sheBoogie).animation = "";
		(items[2] as IMaryShelleyStoryLayout_sheBoogie).isButton = true;
		(items[2] as IMaryShelleyStoryLayout_sheBoogie).option = "boogie";
		items[2].x = 708.55;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"friends"});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_sheBestfriends.call(items[3] as IMaryShelleyStoryLayout_sheBestfriends);
		(items[3] as IMaryShelleyStoryLayout_sheBestfriends).animation = "";
		(items[3] as IMaryShelleyStoryLayout_sheBestfriends).isButton = true;
		(items[3] as IMaryShelleyStoryLayout_sheBestfriends).option = "friends";
		items[3].x = 315.5;
		items[3].y = 68.85;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"isPaperLayer":true});
	}
	if (items[4]) {
		MaryShelleyStoryLayout_paperLayer.call(items[4] as IMaryShelleyStoryLayout_paperLayer);
		(items[4] as IMaryShelleyStoryLayout_paperLayer).isPaperLayer = true;
		items[4].x = 0;
		items[4].y = 0;
		items[4].width = 2048.00;
		items[4].height = 1536.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"","isButton":true,"option":"boogie"});
	}
	if (items[5]) {
		MaryShelleyStoryLayout_sheXFunny_3.call(items[5] as IMaryShelleyStoryLayout_sheXFunny_3);
		(items[5] as IMaryShelleyStoryLayout_sheXFunny_3).animation = "";
		(items[5] as IMaryShelleyStoryLayout_sheXFunny_3).isButton = true;
		(items[5] as IMaryShelleyStoryLayout_sheXFunny_3).option = "boogie";
		items[5].x = 380.5;
		items[5].y = 531.6;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"","isButton":true,"option":"friends"});
	}
	if (items[6]) {
		MaryShelleyStoryLayout_sheXFunny_3.call(items[6] as IMaryShelleyStoryLayout_sheXFunny_3);
		(items[6] as IMaryShelleyStoryLayout_sheXFunny_3).animation = "";
		(items[6] as IMaryShelleyStoryLayout_sheXFunny_3).isButton = true;
		(items[6] as IMaryShelleyStoryLayout_sheXFunny_3).option = "friends";
		items[6].x = 380.5;
		items[6].y = 531.6;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":true,"option":"pie"});
	}
	if (items[7]) {
		MaryShelleyStoryLayout_sheXFunny_4.call(items[7] as IMaryShelleyStoryLayout_sheXFunny_4);
		(items[7] as IMaryShelleyStoryLayout_sheXFunny_4).animation = "";
		(items[7] as IMaryShelleyStoryLayout_sheXFunny_4).isButton = true;
		(items[7] as IMaryShelleyStoryLayout_sheXFunny_4).option = "pie";
		items[7].x = 380.5;
		items[7].y = 531.6;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"","isButton":true,"option":"tickle"});
	}
	if (items[8]) {
		MaryShelleyStoryLayout_sheXFunny_3.call(items[8] as IMaryShelleyStoryLayout_sheXFunny_3);
		(items[8] as IMaryShelleyStoryLayout_sheXFunny_3).animation = "";
		(items[8] as IMaryShelleyStoryLayout_sheXFunny_3).isButton = true;
		(items[8] as IMaryShelleyStoryLayout_sheXFunny_3).option = "tickle";
		items[8].x = 380.5;
		items[8].y = 531.6;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":true,"option":"boogie"});
	}
	if (items[9]) {
		MaryShelleyStoryLayout_slotEncounter3.call(items[9] as IMaryShelleyStoryLayout_slotEncounter3);
		(items[9] as IMaryShelleyStoryLayout_slotEncounter3).animation = "";
		(items[9] as IMaryShelleyStoryLayout_slotEncounter3).isButton = true;
		(items[9] as IMaryShelleyStoryLayout_slotEncounter3).option = "boogie";
		items[9].x = 1333.95;
		items[9].y = 1164.3;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"","isButton":true,"option":"friends"});
	}
	if (items[10]) {
		MaryShelleyStoryLayout_slotEncounter1.call(items[10] as IMaryShelleyStoryLayout_slotEncounter1);
		(items[10] as IMaryShelleyStoryLayout_slotEncounter1).animation = "";
		(items[10] as IMaryShelleyStoryLayout_slotEncounter1).isButton = true;
		(items[10] as IMaryShelleyStoryLayout_slotEncounter1).option = "friends";
		items[10].x = 1333.95;
		items[10].y = 1164.3;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"","isButton":true,"option":"pie"});
	}
	if (items[11]) {
		MaryShelleyStoryLayout_slotEncounter4.call(items[11] as IMaryShelleyStoryLayout_slotEncounter4);
		(items[11] as IMaryShelleyStoryLayout_slotEncounter4).animation = "";
		(items[11] as IMaryShelleyStoryLayout_slotEncounter4).isButton = true;
		(items[11] as IMaryShelleyStoryLayout_slotEncounter4).option = "pie";
		items[11].x = 1333.95;
		items[11].y = 1164.3;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"","isButton":true,"option":"tickle"});
	}
	if (items[12]) {
		MaryShelleyStoryLayout_slotEncounter2.call(items[12] as IMaryShelleyStoryLayout_slotEncounter2);
		(items[12] as IMaryShelleyStoryLayout_slotEncounter2).animation = "";
		(items[12] as IMaryShelleyStoryLayout_slotEncounter2).isButton = true;
		(items[12] as IMaryShelleyStoryLayout_slotEncounter2).option = "tickle";
		items[12].x = 1333.95;
		items[12].y = 1164.3;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"isPaperLayer":true});
	}
	if (items[13]) {
		MaryShelleyStoryLayout_paperLayer.call(items[13] as IMaryShelleyStoryLayout_paperLayer);
		(items[13] as IMaryShelleyStoryLayout_paperLayer).isPaperLayer = true;
		items[13].x = 0;
		items[13].y = 0;
		items[13].width = 2048.00;
		items[13].height = 1536.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"","isButton":true,"option":"pie"});
	}
	if (items[14]) {
		MaryShelleyStoryLayout_shePie.call(items[14] as IMaryShelleyStoryLayout_shePie);
		(items[14] as IMaryShelleyStoryLayout_shePie).animation = "";
		(items[14] as IMaryShelleyStoryLayout_shePie).isButton = true;
		(items[14] as IMaryShelleyStoryLayout_shePie).option = "pie";
		items[14].x = 644.65;
		items[14].y = 989.75;
		if (items[14].onLayout) items[14].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheBoogie(this: IMaryShelleyStoryLayout_sheBoogie) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"slideIn down time=0.4 ease=sineIn"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBoogieAnimatable.call(items[0] as IMaryShelleyStoryLayout_sheBoogieAnimatable);
		(items[0] as IMaryShelleyStoryLayout_sheBoogieAnimatable).animation = "slideIn down time=0.4 ease=sineIn";
		items[0].x = 239;
		items[0].y = 532;
		items[0].width = 478.00;
		items[0].height = 532.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheBoogieAnimatable(this: IMaryShelleyStoryLayout_sheBoogieAnimatable) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-boogie.png", 0.500, 1.000);
	return this;
}
function MaryShelleyStoryLayout_sheBestfriends(this: IMaryShelleyStoryLayout_sheBestfriends) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"tickle time=0.25"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBestfriendsAnimatable.call(items[0] as IMaryShelleyStoryLayout_sheBestfriendsAnimatable);
		(items[0] as IMaryShelleyStoryLayout_sheBestfriendsAnimatable).animation = "tickle time=0.25";
		items[0].x = 750;
		items[0].y = 231;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheBestfriendsAnimatable(this: IMaryShelleyStoryLayout_sheBestfriendsAnimatable) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheBestfriends3.call(items[0] as IMaryShelleyStoryLayout_sheBestfriends3);
		items[0].x = 40.1;
		items[0].y = -187.8;
		items[0].width = 76.00;
		items[0].height = 78.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheBestfriends2.call(items[1] as IMaryShelleyStoryLayout_sheBestfriends2);
		items[1].x = -357.25;
		items[1].y = -185.75;
		items[1].width = 141.00;
		items[1].height = 150.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheBestfriends1.call(items[2] as IMaryShelleyStoryLayout_sheBestfriends1);
		items[2].x = -750;
		items[2].y = -9.4;
		items[2].width = 219.00;
		items[2].height = 229.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		MaryShelleyStoryLayout_sheBestfriends3.call(items[3] as IMaryShelleyStoryLayout_sheBestfriends3);
		items[3].x = -682.3;
		items[3].y = -157.9;
		items[3].rotation = -0.4360;
		items[3].width = 76.00;
		items[3].height = 78.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		MaryShelleyStoryLayout_sheBestfriends3.call(items[4] as IMaryShelleyStoryLayout_sheBestfriends3);
		items[4].x = 674;
		items[4].y = -107.05;
		items[4].rotation = -0.0253;
		items[4].width = 76.00;
		items[4].height = 78.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		MaryShelleyStoryLayout_sheBestfriends1.call(items[5] as IMaryShelleyStoryLayout_sheBestfriends1);
		items[5].x = 477.85;
		items[5].y = -281;
		items[5].rotation = 0.8094;
		items[5].width = 218.99;
		items[5].height = 228.99;
		if (items[5].onLayout) items[5].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheBestfriends3(this: IMaryShelleyStoryLayout_sheBestfriends3) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bestfriends3.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheBestfriends2(this: IMaryShelleyStoryLayout_sheBestfriends2) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bestfriends2.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheBestfriends1(this: IMaryShelleyStoryLayout_sheBestfriends1) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bestfriends1.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheXFunny_3(this: IMaryShelleyStoryLayout_sheXFunny_3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheXFunny_5.call(items[0] as IMaryShelleyStoryLayout_sheXFunny_5);
		items[0].x = 178.5;
		items[0].y = 651;
		items[0].width = 357.00;
		items[0].height = 651.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheXFunny_5(this: IMaryShelleyStoryLayout_sheXFunny_5) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-funny.png", 0.500, 1.000);
	return this;
}
function MaryShelleyStoryLayout_sheXFunny_4(this: IMaryShelleyStoryLayout_sheXFunny_4) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"jump delay=0.35"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheXFunny_4Animatable.call(items[0] as IMaryShelleyStoryLayout_sheXFunny_4Animatable);
		(items[0] as IMaryShelleyStoryLayout_sheXFunny_4Animatable).animation = "jump delay=0.35";
		items[0].x = 178.5;
		items[0].y = 651;
		items[0].width = 357.00;
		items[0].height = 651.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheXFunny_4Animatable(this: IMaryShelleyStoryLayout_sheXFunny_4Animatable) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-funny.png", 0.500, 1.000);
	return this;
}
function MaryShelleyStoryLayout_slotEncounter3(this: IMaryShelleyStoryLayout_slotEncounter3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"dance delay=0.4","isButton":false,"option":""});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_slotEncounter.call(items[0] as IMaryShelleyStoryLayout_slotEncounter);
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).animation = "dance delay=0.4";
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).isButton = false;
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_slotEncounter1(this: IMaryShelleyStoryLayout_slotEncounter1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_slotEncounter.call(items[0] as IMaryShelleyStoryLayout_slotEncounter);
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).animation = "";
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).isButton = false;
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_slotEncounter4(this: IMaryShelleyStoryLayout_slotEncounter4) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"jump delay=0.35","isButton":false,"option":""});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_slotEncounter.call(items[0] as IMaryShelleyStoryLayout_slotEncounter);
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).animation = "jump delay=0.35";
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).isButton = false;
		(items[0] as IMaryShelleyStoryLayout_slotEncounter).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_slotEncounter2(this: IMaryShelleyStoryLayout_slotEncounter2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"tickle"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_slotEncounterTickle.call(items[0] as IMaryShelleyStoryLayout_slotEncounterTickle);
		(items[0] as IMaryShelleyStoryLayout_slotEncounterTickle).animation = "tickle";
		items[0].x = 53.1;
		items[0].y = -260.25;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_slotEncounterTickle(this: IMaryShelleyStoryLayout_slotEncounterTickle) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"ant"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_sheFeather.call(items[0] as IMaryShelleyStoryLayout_sheFeather);
		(items[0] as IMaryShelleyStoryLayout_sheFeather).option = "ant";
		items[0].x = -408.1;
		items[0].y = -111.7;
		items[0].rotation = 0.7136;
		items[0].width = 202.98;
		items[0].height = 329.97;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"superhero"});
	}
	if (items[1]) {
		MaryShelleyStoryLayout_sheSuperheroArmout.call(items[1] as IMaryShelleyStoryLayout_sheSuperheroArmout);
		(items[1] as IMaryShelleyStoryLayout_sheSuperheroArmout).option = "superhero";
		items[1].x = -294.55;
		items[1].y = -414.65;
		items[1].width = 437.00;
		items[1].height = 697.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"ghost"});
	}
	if (items[2]) {
		MaryShelleyStoryLayout_sheGhost.call(items[2] as IMaryShelleyStoryLayout_sheGhost);
		(items[2] as IMaryShelleyStoryLayout_sheGhost).option = "ghost";
		items[2].x = -365.85;
		items[2].y = -538.25;
		items[2].width = 627.00;
		items[2].height = 841.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"ant"});
	}
	if (items[3]) {
		MaryShelleyStoryLayout_sheAnt.call(items[3] as IMaryShelleyStoryLayout_sheAnt);
		(items[3] as IMaryShelleyStoryLayout_sheAnt).option = "ant";
		items[3].x = -407.6;
		items[3].y = -185;
		items[3].width = 624.00;
		items[3].height = 471.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"monster"});
	}
	if (items[4]) {
		MaryShelleyStoryLayout_sheBookmonsterArmdown.call(items[4] as IMaryShelleyStoryLayout_sheBookmonsterArmdown);
		(items[4] as IMaryShelleyStoryLayout_sheBookmonsterArmdown).option = "monster";
		items[4].x = -577.85;
		items[4].y = -423.4;
		items[4].width = 447.00;
		items[4].height = 375.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"monster"});
	}
	if (items[5]) {
		MaryShelleyStoryLayout_sheBookmonster.call(items[5] as IMaryShelleyStoryLayout_sheBookmonster);
		(items[5] as IMaryShelleyStoryLayout_sheBookmonster).option = "monster";
		items[5].x = -335.8;
		items[5].y = -645.75;
		items[5].width = 996.00;
		items[5].height = 906.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"option":"superhero"});
	}
	if (items[6]) {
		MaryShelleyStoryLayout_sheFeather.call(items[6] as IMaryShelleyStoryLayout_sheFeather);
		(items[6] as IMaryShelleyStoryLayout_sheFeather).option = "superhero";
		items[6].x = -348.55;
		items[6].y = -128.8;
		items[6].rotation = 0.8629;
		items[6].width = 203.00;
		items[6].height = 329.99;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"ghost"});
	}
	if (items[7]) {
		MaryShelleyStoryLayout_sheFeather.call(items[7] as IMaryShelleyStoryLayout_sheFeather);
		(items[7] as IMaryShelleyStoryLayout_sheFeather).option = "ghost";
		items[7].x = -465.65;
		items[7].y = -191.75;
		items[7].rotation = 0.3527;
		items[7].width = 202.99;
		items[7].height = 329.99;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"option":"monster"});
	}
	if (items[8]) {
		MaryShelleyStoryLayout_sheFeather.call(items[8] as IMaryShelleyStoryLayout_sheFeather);
		(items[8] as IMaryShelleyStoryLayout_sheFeather).option = "monster";
		items[8].x = -589.2;
		items[8].y = -218.6;
		items[8].rotation = 0.1260;
		items[8].width = 202.99;
		items[8].height = 329.98;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_sheFeather(this: IMaryShelleyStoryLayout_sheFeather) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-feather.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheSuperheroArmout(this: IMaryShelleyStoryLayout_sheSuperheroArmout) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-superhero-armout.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_sheBookmonsterArmdown(this: IMaryShelleyStoryLayout_sheBookmonsterArmdown) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bookmonster-armdown.png", 0.000, 0.000);
	return this;
}
function MaryShelleyStoryLayout_shePie(this: IMaryShelleyStoryLayout_shePie) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"drop"});
	}
	if (items[0]) {
		MaryShelleyStoryLayout_shePieAnimatable.call(items[0] as IMaryShelleyStoryLayout_shePieAnimatable);
		(items[0] as IMaryShelleyStoryLayout_shePieAnimatable).animation = "drop";
		items[0].x = 309.5;
		items[0].y = 316;
		items[0].width = 619.00;
		items[0].height = 260.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MaryShelleyStoryLayout_shePieAnimatable(this: IMaryShelleyStoryLayout_shePieAnimatable) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-pie.png", 0.500, 1.215);
	return this;
}
interface IMaryShelleyStoryLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IMaryShelleyStoryLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IMaryShelleyStoryLayoutSprite extends IMaryShelleyStoryLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IMaryShelleyStoryLayoutText extends IMaryShelleyStoryLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IMaryShelleyStoryLayoutPolygon extends Array<number> {
}
interface IMaryShelleyStoryLayout {
	readonly scene1Start: IMaryShelleyStoryLayout_scene1Start;
	readonly scene2Encounter: IMaryShelleyStoryLayout_scene2Encounter;
	readonly scene3Reaction: IMaryShelleyStoryLayout_scene3Reaction;
	readonly scene4Trait: IMaryShelleyStoryLayout_scene4Trait;
	readonly scene5Trait: IMaryShelleyStoryLayout_scene5Trait;
	readonly scene6End: IMaryShelleyStoryLayout_scene6End;
}
interface IMaryShelleyStoryLayout_scene1Start extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBg|IMaryShelleyStoryLayout_paperLayer|IMaryShelleyStoryLayout_slotXavier>;
}
interface IMaryShelleyStoryLayout_sheBg extends IMaryShelleyStoryLayoutSprite {
}
interface IMaryShelleyStoryLayout_paperLayer extends IMaryShelleyStoryLayoutContainer {
	isPaperLayer: boolean;
}
interface IMaryShelleyStoryLayout_slotXavier extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheXSurprised|IMaryShelleyStoryLayout_sheXSpooky|IMaryShelleyStoryLayout_sheXFunny>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheXSurprised extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheXSpooky extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheXFunny extends IMaryShelleyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_scene2Encounter extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBg|IMaryShelleyStoryLayout_paperLayer|IMaryShelleyStoryLayout_slotXavier|IMaryShelleyStoryLayout_slotEncounter0>;
}
interface IMaryShelleyStoryLayout_slotEncounter0 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheSuperhero0|IMaryShelleyStoryLayout_sheGhost0|IMaryShelleyStoryLayout_sheAnt0|IMaryShelleyStoryLayout_sheBookmonster0>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheSuperhero0 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_shesuperheroAnimatable>;
	option: string;
}
interface IMaryShelleyStoryLayout_shesuperheroAnimatable extends IMaryShelleyStoryLayoutSprite {
	animation: string;
}
interface IMaryShelleyStoryLayout_sheGhost0 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheGhostAnimatable>;
	option: string;
}
interface IMaryShelleyStoryLayout_sheGhostAnimatable extends IMaryShelleyStoryLayoutSprite {
	animation: string;
}
interface IMaryShelleyStoryLayout_sheAnt0 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheAntAnimatable>;
	option: string;
}
interface IMaryShelleyStoryLayout_sheAntAnimatable extends IMaryShelleyStoryLayoutSprite {
	animation: string;
}
interface IMaryShelleyStoryLayout_sheBookmonster0 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBookmonsterAnimatable>;
	option: string;
}
interface IMaryShelleyStoryLayout_sheBookmonsterAnimatable extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBookmonsterArmup|IMaryShelleyStoryLayout_sheBookmonster>;
	animation: string;
}
interface IMaryShelleyStoryLayout_sheBookmonsterArmup extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheBookmonster extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_scene3Reaction extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBg|IMaryShelleyStoryLayout_paperLayer|IMaryShelleyStoryLayout_slotXavier1|IMaryShelleyStoryLayout_slotEncounter>;
}
interface IMaryShelleyStoryLayout_slotXavier1 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheXRun|IMaryShelleyStoryLayout_sheXHide|IMaryShelleyStoryLayout_sheXInvisible|IMaryShelleyStoryLayout_sheXStatue>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheXRun extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheXHide extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheXInvisible extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheXStatue extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_slotEncounter extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheSuperhero|IMaryShelleyStoryLayout_sheGhost|IMaryShelleyStoryLayout_sheAnt|IMaryShelleyStoryLayout_sheBookmonsterArmup|IMaryShelleyStoryLayout_sheBookmonster>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheSuperhero extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheGhost extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheAnt extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_scene4Trait extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBg|IMaryShelleyStoryLayout_paperLayer|IMaryShelleyStoryLayout_slotXavier2|IMaryShelleyStoryLayout_slotEncounter>;
}
interface IMaryShelleyStoryLayout_slotXavier2 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheXBrave|IMaryShelleyStoryLayout_sheXKind|IMaryShelleyStoryLayout_sheXFunny_2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheXBrave extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheXKind extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheXFunny_2 extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_scene5Trait extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBg|IMaryShelleyStoryLayout_paperLayer|IMaryShelleyStoryLayout_slotEncounter|IMaryShelleyStoryLayout_slotXavier3>;
}
interface IMaryShelleyStoryLayout_slotXavier3 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheXDefend|IMaryShelleyStoryLayout_sheXShare|IMaryShelleyStoryLayout_sheXFunny|IMaryShelleyStoryLayout_sheWandButtonimg|IMaryShelleyStoryLayout_sheLanternButtonimg|IMaryShelleyStoryLayout_sheFlashlightButtonimg|IMaryShelleyStoryLayout_sheBroccoliButtonimg|IMaryShelleyStoryLayout_sheToyButtonimg|IMaryShelleyStoryLayout_sheTeddybearButtonimg|IMaryShelleyStoryLayout_sheSandwichButtonimg|IMaryShelleyStoryLayout_sheCrayonsButtonimg|IMaryShelleyStoryLayout_sheTophatButtonimg|IMaryShelleyStoryLayout_sheSillyglassesButtonimg|IMaryShelleyStoryLayout_sheMoustacheButtonimg|IMaryShelleyStoryLayout_sheBowtieButtonimg>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheXDefend extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheXShare extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheWandButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheLanternButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheFlashlightButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheBroccoliButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheToyButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheTeddybearButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheSandwichButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheCrayonsButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheTophatButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheSillyglassesButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheMoustacheButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheBowtieButtonimg extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_scene6End extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBg|IMaryShelleyStoryLayout_paperLayer|IMaryShelleyStoryLayout_sheBoogie|IMaryShelleyStoryLayout_sheBestfriends|IMaryShelleyStoryLayout_sheXFunny_3|IMaryShelleyStoryLayout_sheXFunny_4|IMaryShelleyStoryLayout_slotEncounter3|IMaryShelleyStoryLayout_slotEncounter1|IMaryShelleyStoryLayout_slotEncounter4|IMaryShelleyStoryLayout_slotEncounter2|IMaryShelleyStoryLayout_shePie>;
}
interface IMaryShelleyStoryLayout_sheBoogie extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBoogieAnimatable>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheBoogieAnimatable extends IMaryShelleyStoryLayoutSprite {
	animation: string;
}
interface IMaryShelleyStoryLayout_sheBestfriends extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBestfriendsAnimatable>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheBestfriendsAnimatable extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheBestfriends3|IMaryShelleyStoryLayout_sheBestfriends2|IMaryShelleyStoryLayout_sheBestfriends1>;
	animation: string;
}
interface IMaryShelleyStoryLayout_sheBestfriends3 extends IMaryShelleyStoryLayoutSprite {
}
interface IMaryShelleyStoryLayout_sheBestfriends2 extends IMaryShelleyStoryLayoutSprite {
}
interface IMaryShelleyStoryLayout_sheBestfriends1 extends IMaryShelleyStoryLayoutSprite {
}
interface IMaryShelleyStoryLayout_sheXFunny_3 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheXFunny_5>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheXFunny_5 extends IMaryShelleyStoryLayoutSprite {
}
interface IMaryShelleyStoryLayout_sheXFunny_4 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheXFunny_4Animatable>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_sheXFunny_4Animatable extends IMaryShelleyStoryLayoutSprite {
	animation: string;
}
interface IMaryShelleyStoryLayout_slotEncounter3 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_slotEncounter>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_slotEncounter1 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_slotEncounter>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_slotEncounter4 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_slotEncounter>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_slotEncounter2 extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_slotEncounterTickle>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_slotEncounterTickle extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_sheFeather|IMaryShelleyStoryLayout_sheSuperheroArmout|IMaryShelleyStoryLayout_sheGhost|IMaryShelleyStoryLayout_sheAnt|IMaryShelleyStoryLayout_sheBookmonsterArmdown|IMaryShelleyStoryLayout_sheBookmonster>;
	animation: string;
}
interface IMaryShelleyStoryLayout_sheFeather extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheSuperheroArmout extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_sheBookmonsterArmdown extends IMaryShelleyStoryLayoutSprite {
	option: string;
}
interface IMaryShelleyStoryLayout_shePie extends IMaryShelleyStoryLayoutContainer {
	readonly items: IMaryShelleyStoryLayoutArray<IMaryShelleyStoryLayout_shePieAnimatable>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMaryShelleyStoryLayout_shePieAnimatable extends IMaryShelleyStoryLayoutSprite {
	animation: string;
}
